import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { LayerConstructionOptions, layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import legendImage from '../../img/geo_model.png'
import { ContextTag } from '../wiki/Wiki'

/**
 * Map layer class that draws the model areas for Geo's underground models.
 */
class ModelAreaLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 1.0
  }

  constructor (options: LayerConstructionOptions) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.MODEL_AREAS,
      enabled: true,
      minZoom: 4,
      zIndex: Number.MAX_SAFE_INTEGER - 1
    }
    super({ ...defaultOptions, ...options })

    const opacity = options.params?.opacity === undefined ? ModelAreaLayer.defaultParams.opacity : options.params?.opacity

    const models = options.geoModels
    const selectedGeoModel = options.selectedGeoModel

    const features: ol.Feature[] = []
    if (models !== undefined) {
      models.forEach(model => {
        const feature = new ol.Feature({
          geometry: new ol.geom.LineString(model.Geometry.coordinates[0]),
          type: 'model_area',
          name: model.Name,
          id: model.ID
        })

        const defaultColor = model.Type === 1 ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 255, 1)'

        const selected = selectedGeoModel !== undefined && model.ID === selectedGeoModel
        feature.setStyle(new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: selected ? 'rgba(255, 192, 1, 1)' : defaultColor,
            width: selected ? 4 : 1.5
          })
        }))

        features.push(feature)
      })
    }

    this.olLayer = new ol.layer.Vector({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.Vector({
        features: features
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.MODEL_AREAS,
      name: 'map.layer.modelarea',
      group: LayerGroup.SUBSURFACE,
      ordering: 1,
      contextTags: [
        ContextTag.MODEL_AREAS
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: true,
      imageLegend: {
        legendImage: legendImage,
        imageWidth: 300
      },
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

export default ModelAreaLayer
